import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReadTrackingService } from 'src/app/services/read-tracking.service';

@Component({
  selector: 'navigation-arrows',
  templateUrl: './navigation-arrows.component.html',
})
export class NavigationArrowsComponent implements OnInit {
  @Input() prevUuid?: string;
  @Input() nextUuid?: string;
  @Input() resourceType: string;
  @Input() sortDirection: string;

  currentQueryParams: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private readTrackingService: ReadTrackingService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.currentQueryParams = params;
    });
  }

  navigateLeft() {
    if (this.nextUuid) {
      this.router.navigate([`${this.resourceType}/${this.nextUuid}`], {
        queryParams: this.readTrackingService.withArrowNavigationSource(this.currentQueryParams || {}),
      });
    }
  }

  navigateRight() {
    if (this.prevUuid) {
      this.router.navigate([`${this.resourceType}/${this.prevUuid}`], {
        queryParams: this.readTrackingService.withArrowNavigationSource(this.currentQueryParams || {}),
      });
    }
  }

  arrowColor() {
    return 'text-ternary border-ternary';
  }
}
